import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { Content } from "@/types/content";
import {
  Box,
  IconButton,
  Image,
  Tooltip,
  useDisclosure,
} from "@chakra-ui/react";
import { RiDeleteBin4Line } from "@remixicon/react";
import { useState } from "react";
import SmrDeleteModal from "./deletemodal";
import Client4 from "@/services/api/client4";
import { contentRemove } from "@/reducer/contentSlice";
import { selectCurrentImage, setCurrentImage } from "@/reducer/designslice";

type Props = {
  content: Content;
  onDelete: (contentId: string) => void;
};

const SmrHistoryItem = (props: Props) => {
  const { content, onDelete } = props;
  const dispatch = useAppDispatch();
  const deleteControl = useDisclosure();
  const [hovered, setHovered] = useState(false);
  const [currentContentId, setCurrentContentId] = useState("");
  // const user = useAppSelector(selectUser);
  const currentImage = useAppSelector(selectCurrentImage);

  let type =
    content.type === "TextToImage"
      ? "生图"
      : content.type === "Outpaint"
      ? "扩图"
      : content.type === "SmrToImage"
      ? "毛坯房出图"
      : content.type === "Upload"
      ? "上传"
      : "";

  const handleClickImage = () => {
    dispatch(setCurrentImage(content));
  };
  

  return (
    <Box
      background={
        currentImage.id === content.id
          ? "linear-gradient(90deg, #66E8E0 0%, #496AE1 100%)"
          : "#6C7596"
      }
      // background={ "#6C7596"}
      borderRadius="10px"
      p={currentImage.id === content.id ? "3px" : "1px"}
      mb="10px"
      overflow={"hidden"}
      onClick={handleClickImage}
    >
      <Box
        h="106px"
        overflow={"hidden"}
        borderRadius="10px"
        bg="#161922"
        position={"relative"}
      >
        <Image
          w="100%"
          h="106px"
          objectFit={"cover"}
          cursor="pointer"
          src={content.thumbnail_url}
        />
        {type && (
          <Box
            position={"absolute"}
            top="5px"
            right={"5px"}
            h="22px"
            pl="4px"
            pr="4px"
            borderRadius={"4px"}
            bg="#1E253F"
            fontSize={"12px"}
            color="#FFFFFF"
            textAlign={"center"}
            lineHeight="22px"
          >
            {type}
          </Box>
        )}

        {/* <Box
          position={"absolute"}
          top="5px"
          right={"5px"}
          w="40px"
          h="22px"
          borderRadius={"6px"}
          bg="#1E253F"
          fontSize={"14px"}
          color="#FFFFFF"
          textAlign={"center"}
          lineHeight="22px"
        >
          {content.length}张
        </Box> */}
        <Box
          position={"absolute"}
          bottom="5px"
          right={"5px"}
          bg="#1E253F"
          borderRadius={"4px"}
        >
          <Tooltip label="删除" placement="top">
            <IconButton
              aria-label="delete img"
              size="xs"
              variant="unstyle"
              color="white"
              icon={<RiDeleteBin4Line size={16} />}
              _hover={{ color: "#8E94A9" }}
              onClick={() => onDelete(content.id)}
            />
          </Tooltip>
        </Box>
      </Box>
    </Box>
  );
};

export default SmrHistoryItem;
